/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import { mountModal } from 'lib/modal';
import EmailMergeConfirmation from 'user/components/EmailMergeConfirmation.jsx';
import AuthActions from 'auth/AuthActions';

const EVENT_SCREEN_NAME = 'sign_up_flow';

class EmailForm extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    onSave: PropTypes.func.isRequired,
  };

  state = {
    enabled: false,
    enteredEmail: '',
    errorMessage: '',
  };

  logout() {
    AuthActions.signOut('/log_in');
  }

  renderEmailMergeConfirmation() {
    return (
      <EmailMergeConfirmation
        oldUserEmail={this.state.enteredEmail}
        errorMessage={this.state.errorMessage}
        onDone={this.logout}
        eventScreenName={EVENT_SCREEN_NAME}
        // XXX should EmailMergeConfirmation require onRequestHide?
        onRequestHide={() => null}
      />
    );
  }

  submit = (attrs: Object) => {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Saved!');
      this.props.onSave();
    };

    const onFailure = error => {
      let errorMessage;
      if (error.field_errors) {
        errorMessage = error.field_errors
          .map(fieldError => fieldError.messages.join(', '))
          .join(', ');
      } else {
        errorMessage = error.message;
      }
      this.setState({ errorMessage, enteredEmail: attrs.email });
      mountModal(this.renderEmailMergeConfirmation(), this);
    };

    UserActions.update(attrs).then(onSuccess, onFailure);
  };

  render() {
    return (
      <div className="EmailForm">
        <Form
          onValidSubmit={this.submit}
          onValid={() => this.setState({ enabled: true })}
          onInvalid={() => this.setState({ enabled: false })}>
          <div className="EmailForm-email">
            <FormInput
              label="Email address"
              className="EmailForm-emailInput"
              placeholder="name@email.com"
              name="email"
              validations="isEmail"
              validationErrors={{
                isEmail: 'Invalid email address.',
              }}
              showErrorAfterBlur
              value={CurrentUser.getUser().getEmail() || ''}
            />
          </div>
          <Button
            disabled={!this.state.enabled}
            className="EmailForm-submit"
            type="submit"
            eventElementName="EmailForm-submit">
            Done
          </Button>
        </Form>
      </div>
    );
  }
}

export default EmailForm;
